import angular from "angular";
import uiRouter from "angular-ui-router";
import postorderComponent from "./postorder.component";

let postorderModule = angular
  .module("postorder", [uiRouter])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider.state("postorder", {
      url: "/postorder",
      template: "<postorder></postorder>",
      params: {
        jobType: null,
        pay: null,
        openings: null,
        pt: null,
        job_posting_type: null,
        job_title: null,
        jobble_type: null,
        hourly_rate: null,
        pay_rate: null,
        pay_rate_jblr: null,
        dress_code: null,
        job_description: null,
        preserve: null,
        t: null,
        date_time: null,
        instructions: null,
        location: null,
        street_line_1: null,
      },
      onExit: ["$rootScope", function ($rootScope) {}],
    });
  })

  .component("postorder", postorderComponent);

export default postorderModule;



// WEBPACK FOOTER //
// ./client/app/components/postorder/postorder.js